import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { Card, CardContent } from '@material-ui/core';

import { TypographyProps, Typography } from './Typography';

const messages = defineMessages({
  message: {
    id: 'embeds.components.v2.EmptyStateTable.message',
    defaultMessage: 'No data yet',
  },
});

export interface EmptyStateTableProps extends Omit<TypographyProps, 'classes'> {}

const EmptyStateTable: React.FC<EmptyStateTableProps> = ({ children, ...rest }) => {
  const { formatMessage } = useIntl();

  return (
    <Card elevation={0}>
      <CardContent>
        <Typography variant="body1" color="textSecondary" {...rest}>
          <i>{children || formatMessage(messages.message)}</i>
        </Typography>
      </CardContent>
    </Card>
  );
};

export default EmptyStateTable;
